import { render, staticRenderFns } from "./SkillIcon.vue?vue&type=template&id=f581ee0c&scoped=true&"
import script from "./SkillIcon.vue?vue&type=script&lang=js&"
export * from "./SkillIcon.vue?vue&type=script&lang=js&"
import style0 from "./SkillIcon.vue?vue&type=style&index=0&id=f581ee0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f581ee0c",
  null
  
)

export default component.exports